import { LanguageText } from "./language-text.model";

export class PathwayLangText {
  constructor(
    public name: LanguageText,
    public description: LanguageText,
    public generalConsideration: LanguageText,
    public addInformation: LanguageText
  ) {}
}
